import { IQuiz } from '../IQuiz'

export const ispIntro2: IQuiz = {
  name: 'isp-intro-2',
  question: 'В чём недостаток множественного наследования?',
  variants: [
    {
      text: 'В возможном ромбовидном наследовании'
    },
    {
      text: 'В необходимости композировать наследуемые свойства от нескольких классов-родителей',
      description: 'Композиция наследуемых свойств — преимущество метода'
    },
    {
      text: 'В большом количестве родительских классов',
      description:
        'Цель множественного наследования — в одновременном наследовании свойств от нескольких родителей, таким образом достигается композиция свойств'
    }
  ],
  meta: {
    correctAnswers: [0]
  }
}
